<template lang="pug">
  .curriculum-step-field.input-field
    label {{ `STEP${this.index + 1}` }}

    video-field(
      v-model="video"
      :selectedVideo="selectedVideo"
      @upload="$emit('upload', $event)"
      @playback="playbackVideo")

    multiline-text-field(
      v-model="description"
      :placeholder="`STEP${this.index + 1}の説明を入力`"
    )

    remove-step-button(@click="onRemoveClicked")
</template>

<style lang="scss" scoped>
.input-field {
  background-color: rgba(255, 255, 255, 0.06);
  box-sizing: border-box;
  padding-top: 18px;
  padding-bottom: 20px;
}

label {
  @extend %label-text;
  margin-left: 16px;
  white-space: nowrap;
}

.video-field {
  margin-top: 12px;
}

.multiline-text-field {
  margin: 24px 16px 0 16px;
  height: 156px;
}

.remove-step-button {
  margin-top: 12px;
}
</style>

<script>
import _ from 'lodash'
import VideoPlayable from '@/components/mixins/VideoPlayable'
import VideoField from '@/components/molecules/VideoField'
import MultilineTextField from '@/components/molecules/MultilineTextField'
import RemoveStepButton from '@/components/molecules/RemoveStepButton'

export default {
  props: {
    index: { type: Number },
    value: { type: Object },
  },
  mixins: [VideoPlayable],
  components: {
    VideoField,
    MultilineTextField,
    RemoveStepButton,
  },
  computed: {
    selectedVideo() {
      if (this.value.thumbnailUrl) {
        return _.pick(this.value, ['thumbnailUrl', 'videoUrl'])
      } else {
        return null
      }
    },
    description: {
      get() {
        return this.value.description
      },
      set(description) {
        this.updateValue({ description })
      },
    },
    video: {
      get() {
        return {
          videoKey: this.value.videoKey,
          thumbnailKey: this.value.thumbnailKey,
        }
      },
      set({ videoKey, thumbnailKey }) {
        this.$emit('input', {
          description: this.value.description,
          videoKey,
          thumbnailKey,
        })
      },
    },
  },
  methods: {
    updateValue(diff) {
      this.$emit('input', { ...this.value, ...diff })
    },
    onRemoveClicked() {
      this.$f7.dialog.confirm(
        '本当にこのステップを削除してよろしいですか？',
        '確認',
        () => this.$emit('remove', this.index)
      )
    },
  },
}
</script>
